module.exports = __webpack_public_path__ + "img/debate-club.a28400fd.webp";